[
    {
        "label": "Cartoweb-topo grey",
        "nl": [
            {
                "name": "Bodembedekking",
                "content": "leg1_wm_n_g.png"
            },
            {
                "name": "Lijn- of puntvormige begroeiing",
                "content": "leg2_wm_n_g.png"
            },
            {
                "name": "Gebouwen",
                "content": "leg3_wm_n_g.png"
            },
            {
                "name": "Hydrografie",
                "content": "leg4_wm_n_g.png"
            },
            {
                "name": "Netwerk, wegen en paden",
                "content": "leg5_wm_n_g.png"
            },
            {
                "name": "Bijzondere zones",
                "content": "leg6_wm_n_g.png"
            },
            {
                "name": "Elektrisch hoogspanningsnet",
                "content": "leg7_wm_n_g.png"
            },
            {
                "name": "Terreinvoorstellingen",
                "content": "leg8_wm_n_g.png"
            },
            {
                "name": "Administratieve gegevens",
                "content": "leg9_wm_n_g.png"
            },
            {
                "name": "Toponiemen",
                "content": "leg10_wm_n_g.png"
            },
            {
                "name": "Constructies, diverse objecten",
                "content": "leg11_wm_n_g.png"
            }
        ],
        "fr": [
            {
                "name": "Couverture du sol",
                "content": "leg1_wm_f_g.png"
            },
            {
                "name": "Végétation linéaire et ponctuelle",
                "content": "leg2_wm_f_g.png"
            },
            {
                "name": "Bâtiments",
                "content": "leg3_wm_f_g.png"
            },
            {
                "name": "Hydrographie",
                "content": "leg4_wm_f_g.png"
            },
            {
                "name": "Réseaux, routes et chemins",
                "content": "leg5_wm_f_g.png"
            },
            {
                "name": "Zones particulières",
                "content": "leg6_wm_f_g.png"
            },
            {
                "name": "Réseau électrique haute tension",
                "content": "leg7_wm_f_g.png"
            },
            {
                "name": "Figures du terrain",
                "content": "leg8_wm_f_g.png"
            },
            {
                "name": "Données administratives",
                "content": "leg9_wm_f_g.png"
            },
            {
                "name": "Toponymie",
                "content": "leg10_wm_f_g.png"
            },
            {
                "name": "Constructions, objets divers",
                "content": "leg11_wm_f_g.png"
            }
        ]
    },
    {
        "label": "Secteurs statistiques - Belgique",
        "nl": [
            {
                "name":"test1fnl",
                "content":"test1nl"
            },
            {
                "name":"test2nl",
                "content":"test2nl"
            }
        ],
        "fr": [
            {
                "name":"test1fr",
                "content":"test1fr"
            },
            {
                "name":"test2fr",
                "content":"test2fr"
            }
        ]
    },
    {
        "label": "Top10Vector-Réseau ferroviaire",
        "nl": [
            {
                "name":"Top10Vector1nl",
                "content":"Top10Vector1nl"
            },
            {
                "name":"Top10Vector2nl",
                "content":"Top10Vector2nl"
            }
        ],
        "fr": [
            {
                "name":"Top10Vector1fr",
                "content":"Top10Vector1fr"
            },
            {
                "name":"Top10Vector2fr",
                "content":"Top10Vector2fr"
            }
        ]
    },
    {
        "label": "Top250Map",
        "nl": [
            {
                "name":"Top250Map1fnl",
                "content":"Top250Map1nl"
            },
            {
                "name":"Top250Map2nl",
                "content":"Top250Map2nl"
            }
        ],
        "fr": [
            {
                "name":"Top250Map1fr",
                "content":"Top250Map1fr"
            },
            {
                "name":"Top250Map2fr",
                "content":"Top250Map2fr"
            }
        ]
    }
]